import axios from "axios";
import qs from "qs";
import { baseUrl } from "../config/EnVariables";
const token = localStorage.getItem("access_token"); // Replace with your actual Bearer Token
const user = JSON.parse(localStorage.getItem("user"));
// const baseUrl = "http://localhost:8081/api";
const headers = {
  Authorization: `Bearer ${token}`,
  "Content-Type": "application/json", // Assuming you're sending JSON data
};

const Payment = {
  getAll: () =>
    axios.get(
      `${baseUrl}/payments/branch-payments/?branchId=${user.branchId}`,
      { headers: headers }
    ),

  getOne: (ID) =>
    axios.post(`/rents/findRentById`, {
      critarion: { _id: `${ID}`, active: "true" },
    }),

  getAccounts: () => axios.get("/transfer/accounts"),

  pay: (data) =>
    axios.post(`${baseUrl}/payments/?branchId=${user.branchId}`, data, {
      headers: headers,
    }),

  update: (data, ID) =>
    axios.post(`/rents/updateRent`, { shopkeeperid: ID, ...data }),

  getByMember: (ID, pagination, date) =>
    axios.get(
      `/transfer/member/${ID}?${qs.stringify(pagination)}&${qs.stringify(date)}`
    ),

  remove: (data) => axios.post(`/rents/removeRent`, data),
};

export default Payment;
